export default "__VITE_ASSET__x6JPgJTE__"